// extracted by mini-css-extract-plugin
export var errorsContainer = "_tn-1";
export var link = "_tn-0";